/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateSiteContactResponseData,
  UpdateSiteContactResponseDataFromJSON,
  UpdateSiteContactResponseDataFromJSONTyped,
  UpdateSiteContactResponseDataToJSON
} from './UpdateSiteContactResponseData'

/**
 *
 * @export
 * @interface UpdateSiteContactResponse
 */
export interface UpdateSiteContactResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateSiteContactResponse
   */
  status?: number
  /**
   *
   * @type {UpdateSiteContactResponseData}
   * @memberof UpdateSiteContactResponse
   */
  data?: UpdateSiteContactResponseData
}

export function UpdateSiteContactResponseFromJSON(json: any): UpdateSiteContactResponse {
  return UpdateSiteContactResponseFromJSONTyped(json, false)
}

export function UpdateSiteContactResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSiteContactResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : UpdateSiteContactResponseDataFromJSON(json['data'])
  }
}

export function UpdateSiteContactResponseToJSON(value?: UpdateSiteContactResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: UpdateSiteContactResponseDataToJSON(value.data)
  }
}
